import equivalencesIntRoman from './equivalencesIntRoman';
export default {
	name: "TableRomanConversation",
	data() {
		return {
			tabConversion: equivalencesIntRoman
		}
	}
}